export const DOWNLOAD_ASSET_IMAGE_SUCCESS = "DOWNLOAD_ASSET_IMAGE_SUCCESS";
